import { useEffect, useMemo } from 'react';
import '/assets/styles/pages/menu.scss';

// Sections
import MenuHeader from '/views/sections/menu-header';

// Partials
import CategoryCard from '/views/partials/category-card';

// Context
import { useBranchSelection } from '/utilities/branch-selection';
import { useMenu } from '/utilities/menu';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';

const Menu = () => {
	const { selectedBranch, initialized } = useBranchSelection();
	const { openModal } = useModals();
	const { redirect } = useNavigator();
	const { getMenu, loadMenu } = useMenu();

	const rawCategories = getMenu(selectedBranch?.slug)?.categories;

	const categories = useMemo(
		() => rawCategories ?? [false, false, false, false, false, false, false, false, false],
		[rawCategories]
	);

	useEffect(() => {
		if (selectedBranch) {
			loadMenu(selectedBranch.slug).catch((feedback) => {
				redirect('open');
				openModal('message', { feedback });
			});
		} else if (initialized) {
			redirect('home');
		}
	}, [selectedBranch, initialized, loadMenu]);

	return (
		<>
			<MenuHeader backLink="home" backLinkRedirect />
			<div className="menu-container loader-container">
				{categories && (
					<div className="menu-categories wrapper">
						<ul className="categories-list">
							{categories.map((category, nth) => (
								<li className="list-item" key={category?.id ?? nth}>
									<CategoryCard className="list-category" category={category} />
								</li>
							))}
						</ul>
					</div>
				)}
			</div>
			<div className="menu-decoration"></div>
		</>
	);
};

export default Menu;
